import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";
import { useT } from "../../i18n/LanguageContext";

export default function FAQ() {
    const { t } = useT();
    const faqs = t("faq.items");

    return (
        <section data-testid="faq-section" className="py-24 md:py-32 lg:py-40">
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4 reveal">
                    <p className="overline mb-6">{t("faq.overline")}</p>
                    <h2 className="font-serif text-4xl md:text-5xl tracking-tighter leading-[1.05] text-ink">
                        {t("faq.headlineA")}{" "}
                        <em className="italic font-light text-terracotta">
                            {t("faq.headlineEm")}
                        </em>
                    </h2>
                    <p className="mt-6 text-secondary leading-relaxed">
                        {t("faq.intro")}
                    </p>
                </div>
                <div className="lg:col-span-8 reveal">
                    <Accordion type="single" collapsible className="w-full">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                value={`item-${i}`}
                                key={i}
                                data-testid={`faq-accordion-item-${i}`}
                                className="border-b border-warm"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-accordion-trigger-${i}`}
                                    className="text-left font-serif text-xl md:text-2xl tracking-tight text-ink py-6 hover:no-underline"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-base text-secondary leading-relaxed pb-8 pr-8">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
